import { render, staticRenderFns } from "./ActivityImageButton.vue?vue&type=template&id=12f776d0&scoped=true"
import script from "./ActivityImageButton.vue?vue&type=script&lang=ts"
export * from "./ActivityImageButton.vue?vue&type=script&lang=ts"
import style0 from "./ActivityImageButton.vue?vue&type=style&index=0&id=12f776d0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12f776d0",
  null
  
)

/* custom blocks */
import block0 from "./ActivityImageButton.vue?vue&type=custom&index=0&blockType=docs"
if (typeof block0 === 'function') block0(component)

export default component.exports